import type { ZodError } from 'zod';

export type FieldErrors = Record<string, string>;

export const toFieldErrors = (error: ZodError): FieldErrors => {
	const errors: FieldErrors = {};
	error.issues.forEach((issue) => {
		const key = issue.path.join('.');
		if (key && !errors[key]) errors[key] = issue.message;
	});
	return errors;
};
